module.exports = __webpack_public_path__ + "public/images/bts_hero_image_3.46debffecd4b6d66a39ddc93922034cb.webp";